module.exports = __webpack_public_path__ + "img/mushrooms-food.2711f35f.svg";